import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const Document = Styled(
	createSvgIcon(
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M18.3333 8.33332V12.5C18.3333 16.6667 16.6667 18.3333 12.5 18.3333H7.5C3.33333 18.3333 1.66666 16.6667 1.66666 12.5V7.49999C1.66666 3.33332 3.33333 1.66666 7.5 1.66666H11.6667'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.3333 8.33332H15C12.5 8.33332 11.6667 7.49999 11.6667 4.99999V1.66666L18.3333 8.33332Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.83334 10.8333H10.8333'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.83334 14.1667H9.16667'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'Document'
	)
);

export default Document;
